<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div">会议平台：</div>
          <el-input v-model="page.platformName" class="ipt-sty" placeholder="请输入会议平台"></el-input
        ></el-col>
        <el-col :span="8">
          <div class="search-area-div">启用状态：</div>
          <el-select v-model="page.isOpen" placeholder="请选择启用状态" class="ipt-sty">
            <el-option v-for="item in openStateList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <div style="padding: 20px 20px 0 0; text-align: right">
        <el-button size="medium" type="info" @click="search">搜索</el-button>
        <el-button size="medium" type="danger" @click="emptySearch">清空</el-button>
      </div>
    </div>

    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="addPlatform">新增会议平台</el-button>
    </div>
    <div class="back-color-fff p16">
      <el-table :data="tableData" border style="width: 100%" v-loading="tableLoading" :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="campaignsState" label="会议平台名称" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.platformName }}</template>
        </el-table-column>

        <el-table-column prop="campaignsState" label="登录帐号" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.loginUser }}</template>
        </el-table-column>

        <el-table-column prop="campaignsState" label="展示顺序" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.sort }}</template>
        </el-table-column>
        <el-table-column prop="campaignsState" label="启用状态" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.isOpen == '1' ? '启用' : '禁用' }}</template>
        </el-table-column>
        <el-table-column prop="updateTime" label="操作时间" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.updateTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="bank" min-width="100px" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="editPlatform(scope.row, scope.row.isOpen)"
              >{{ scope.row.isOpen == '1' ? '设为禁用' : '设为启用' }} ｜</a
            >
            <a class="txt-color" @click="editPlatform(scope.row)">编辑 ｜</a>
            <a class="txt-color" style="color: red !important" @click="delVersion(scope.row.guid, scope.row.isOpen)"
              >删除</a
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>

    <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="50%">
      <el-form label-width="140px" :label-position="right" class="demo-ruleForm">
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">会议平台名称 </span>
          <el-input type="input" :maxlength="20" placeholder="请填写会议平台名称" v-model="platformName"> </el-input>
        </el-form-item>
        <el-form-item class="fl">
          <span slot="label" style="color: red">*</span>
          <span slot="label">平台用途 </span>
          <el-radio-group v-model="platformUse">
            <el-radio label="0">开展会议</el-radio>
            <el-radio label="1">海报设计</el-radio>
            <el-radio label="2">其他</el-radio>
          </el-radio-group>
        </el-form-item>
        <div style="clear: both"></div>
        <el-form-item label="平台系统链接">
          <el-input type="input" :maxlength="200" placeholder="请填写平台系统链接" v-model="platformUrl"> </el-input>
        </el-form-item>
        <el-form-item label="腾讯会议userId">
          <el-input type="input" :maxlength="200" placeholder="请填写腾讯会议userId" v-model="userId"> </el-input>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">平台登录账号 </span>
          <el-input type="input" :maxlength="20" placeholder="请填写平台登录账号" v-model="loginUser"> </el-input>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">平台登录密码 </span>
          <el-input type="input" :maxlength="20" placeholder="请填写平台登录账号" v-model="loginPwd"> </el-input>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">平台简述 </span>
          <el-input type="textarea" :rows="5" :maxlength="50" placeholder="请填写平台简述" v-model="note"> </el-input>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">展示顺序 </span>
          <el-input
            type="number"
            placeholder="请填写展示顺序"
            min="1"
            oninput="value=value.replace(/[^\d]/g,'')"
            v-model="sort"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">上传平台图 </span>
          <el-dialog :visible.sync="dialogVisible2">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
          <el-upload
            action="#"
            name="image"
            class="fl"
            :limit="1"
            list-type="picture-card"
            :headers="token"
            :file-list="fileList"
            :on-exceed="handleExceed"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :http-request="uploadImage"
          >
            <div slot="image" slot-scope="{ file }">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                  <i class="el-icon-download"></i>
                </span>
                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible = false">取 消</el-button>
        <el-button
          size="medium"
          type="info"
          v-if="textTitle == '新增平台'"
          @click="addReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
        <el-button
          size="medium"
          type="info"
          v-else
          @click="updateReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >修 改</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      fullscreenLoading: false,
      textTitle: '新增平台',
      dialogVisible: false,
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        platformName: '',
        isOpen: '-1',
        platformUse: -1,
      },
      openStateList: [
        { label: '全部', value: '-1' },
        { label: '启用', value: '1' },
        { label: '禁用', value: '0' },
      ],

      platformName: '', //平台名称
      platformUse: '', //平台用途
      userId: '', //腾讯会议userid
      platformUrl: '', //平台系统链接
      loginUser: '', //登陆账号
      loginPwd: '', //登陆密码
      note: '', //平台简述
      sort: '', //展示顺序
      guid: '',
      tableLoading: false,
      tableData: [],
      height: window.innerHeight - 400,
      right: 'right',

      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      dialogVisible2: false,
      dialogImageUrl: '',
      fileList: [],
      activityAttach: [],
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    search() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: 10,
        platformName: this.page.platformName,
        isOpen: this.page.isOpen,
        platformUse: -1,
      };
      self.tableLoading = true;

      self.api.postJson(`/${serverConfig.msSalesPerformService}/meeting/platform/get-list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        platformName: '',
        isOpen: '-1',
        platformUse: -1,
      };
      this.getList();
    },
    addPlatform() {
      this.textTitle = '新增平台';
      this.userId = '';
      this.platformUrl = '';
      this.platformName = '';
      this.platformUse = '';
      this.loginUser = '';
      this.loginPwd = '';
      this.note = '';
      this.sort = '';

      this.fileList = [];
      this.dialogVisible2 = false;
      this.activityAttach = [];
      this.dialogImageUrl = '';

      this.dialogVisible = true;
    },
    editPlatform(detail, isOpen) {
      this.platformName = detail.platformName;
      this.loginUser = detail.loginUser;
      this.loginPwd = detail.loginPwd;
      this.sort = detail.sort;
      this.guid = detail.guid;
      this.note = detail.note;
      this.platformUse = detail.platformUse + '';
      this.dialogImageUrl = detail.backgroundImageUrl;
      this.platformUrl = detail.platformUrl;
      this.userId = detail.userId;
      this.activityAttach = [
        {
          name: '平台背景图',
          url: detail.backgroundImageUrl,
        },
      ];
      this.fileList = [
        {
          name: '平台背景图',
          url: detail.backgroundImageUrl,
        },
      ];
      if (isOpen == 0 || isOpen == 1) {
        this.updateReqVersion(isOpen);
      } else {
        this.textTitle = '编辑平台';
        this.dialogVisible = true;
      }
      console.log(this.platformUse);
      this.$forceUpdate();
    },
    getList() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/meeting/platform/get-list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    delVersion(guid, isOpen) {
      var self = this;
      if (isOpen == 1) {
        self.$message.error('启用状态不许删除！');
        return;
      }
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msSalesPerformService}/meeting/platform/delete?guid=${guid}`)
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success('删除成功');
                self.page.pageIndex = 1;
                self.getList();
              } else {
                self.$message.error(res.data.msg);
              }
            });
        });
    },
    addReqVersion() {
      var self = this;
      if (!this.platformName) {
        self.$message('请输入平台名称');
        return;
      }
      if (!this.platformUse) {
        self.$message('请输入平台用途');
        return;
      }
      if (!this.loginUser) {
        self.$message('请输入平台登录帐号');
        return;
      }
      if (!this.loginPwd) {
        self.$message('平台登录密码');
        return;
      }
      if (!this.note) {
        self.$message('请输入平台简述');
        return;
      }
      if (!this.sort) {
        self.$message('请输入平台展示顺序');
        return;
      }
      if (this.fileList.length == 0) {
        self.$message('请上传平台背景图');
        return;
      }
      var req = {
        platformName: this.platformName,
        loginUser: this.loginUser,
        loginPwd: this.loginPwd,
        platformUse: this.platformUse + '',
        note: this.note,
        platformUrl: this.platformUrl,
        backgroundImageUrl: this.activityAttach[0].url,
        sort: this.sort,
        isOpen: 1,
        userId: this.userId,
      };

      self.api.postJson(`/${serverConfig.msSalesPerformService}/meeting/platform/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('新增成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    updateReqVersion(isOpen) {
      var self = this;
      if (!this.platformName) {
        self.$message('请输入平台名称');
        return;
      }
      if (!this.platformUse) {
        self.$message('请输入平台用途');
        return;
      }
      if (!this.loginUser) {
        self.$message('请输入平台登录帐号');
        return;
      }
      if (!this.loginPwd) {
        self.$message('平台登录密码');
        return;
      }
      if (!this.note) {
        self.$message('请输入平台简述');
        return;
      }
      if (!this.sort) {
        self.$message('请输入平台展示顺序');
        return;
      }
      if (this.fileList.length == 0) {
        self.$message('请上传平台背景图');
        return;
      }

      var req = {
        platformName: this.platformName,
        loginUser: this.loginUser,
        loginPwd: this.loginPwd,
        platformUse: this.platformUse,
        note: this.note,
        backgroundImageUrl: this.fileList[0].url,
        sort: this.sort,
        guid: this.guid,
        platformUrl: this.platformUrl,
        userId: this.userId,
      };
      if (isOpen == 0 || isOpen == 1) {
        req.isOpen = isOpen == 0 ? 1 : 0;
      }

      self.api.postJson(`/${serverConfig.msSalesPerformService}/meeting/platform/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('编辑成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible2 = true;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handleRemove(file) {
      let self = this;
      console.log(file.url);
      self.activityAttach.forEach(function (i, index) {
        if (i.path == file.url) {
          self.activityAttach.splice(index, 1);
        }
      });
      self.fileList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.fileList.splice(ind, 1);
        }
      });
      console.log(self.fileList);
    },
    uploadImage(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '平台背景图',
              url: res.data.data,
            };
            self.fileList.push(item);
            self.activityAttach.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>